<template>
  <div class="app">
    <h5>APP体验</h5>
    <div class="content">
      <!-- <div>产品开发中，敬请期待</div> -->
      <div
        :style="{ background: 'url(' + require('@/assets/images/experience/neirong_2.png') + ') no-repeat'}"
      ></div>
      <div
        class="dev"
        :style="{ background: 'url(' + require('@/assets/images/experience/phone.png') + ') no-repeat'}"
      >
        <div class>扫码体验下载</div>
        <div class>产品开发中，敬请期待</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.app {
  width: 100%;
}
.content {
  width: 100%;
  position: relative;
  margin-top: 85px;
}
.content > :first-child {
  /* background-image: url(../../../assets/images/experience/neirong.png); */
  height: 670px;
  width: 750px;
  position: absolute;
  left: 50%;
  top: 285px;
  margin-top: -130px;
  margin-left: -585px;
  /* background-repeat: no-repeat; */
  z-index: 2;
}
.content > :last-child {
  height: 780px;
  width: 600px;
  position: absolute;
  left: 50%;
  top: 55px;
  margin-left: 105px;
  /* background-image: url(../../../assets/images/experience/phone.png); */
  /* background-repeat: no-repeat; */
  z-index: 2;
}
.dev > :first-child {
  font-size: 24px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 350px;
  margin-left: -122px;
}
.dev > :last-child {
  width: 220px;
  line-height: 53px;
  background: rgba(241, 241, 241, 1);
  border-radius: 4px;
  font-size: 18px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 120px;
  margin-left: 130px;
}
h5 {
  font-size: 30px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-top: 63px;
  margin-bottom: -110px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/form/formContent.vue